
import { Options, prop, Vue } from "vue-class-component";
import PaginationV3 from "@/app/ui/components/pagination-v3/index.vue";
import { Pagination } from "@/domain/entities/Pagination";
import Skeleton from "@/app/ui/components/skeleton/index.vue";

class Props {
  column = prop<any[]>({
    default: () => [],
    type: Array,
  });
  tableData = prop<any[]>({
    default: () => [],
    type: Array,
  });
  sortBy = prop<string>({
    default: "",
  });
  sortDirection = prop<string>({
    default: "",
  });
  substractHeight = prop<string>({
    default: "377",
  });
  pagination = prop<Pagination>({
    default: () => new Pagination(1, 5, 0),
  });
  loading = prop<boolean>({
    default: false,
  });
  startIndex = prop<number>({
    default: 0
  })
}

@Options({
  components: {
    PaginationV3,
    Skeleton,
  },
  emits: ["set-page"],
})
class TableBillDetail extends Vue.with(Props) {
  onSort(sortBy = "") {
    if (!this.sortDirection || this.sortBy !== sortBy) {
      return this.$emit("sort", { sortBy, sortDirection: "ASC" });
    }
    if (this.sortDirection === "ASC")
      return this.$emit("sort", { sortBy, sortDirection: "DESC" });
    if (this.sortDirection === "DESC")
      return this.$emit("sort", { sortBy: "", sortDirection: "" });
  }

  setPage(page: number) {
    this.$emit("set-page", page);
  }
}

export default TableBillDetail;
